import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const DataIODataExport = () => {
	return <PlaceholderView pageType={PageType.DataIODataExport} text="Data export" />;
};

export default DataIODataExport;
